export enum ExtractionType {
    Quote = 'Quote',
    Policy = 'Policy',
    PolicySpecimen = 'PolicySpecimen',
    ExpiringPolicy = 'ExpiringPolicy',
}
